var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,staticClass:"menu-item",on:{"click":function($event){return _vm.handleMenu(item.path)}}},[_c('a',{attrs:{"href":""}},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }